/**
 * Logout - Handles user logout
 */
import { authLogger } from '@annote/core/utils/debug';
import React, { useEffect } from 'react';
import { useProfileContext } from '../context/ProfileContext';

const Logout: React.FC = () => {
  const { logout } = useProfileContext();

  useEffect(() => {
    logout().then(() => {
      authLogger.info('LOGGED OUT');
      // Force a full page reload to clear all state and redirect to login
      window.location.href = '/login';
    });
  }, [logout]);

  return <div>Logging out...</div>;
};

export default Logout;
